import { Checkbox, Collapse, Divider } from "antd";
import { FC, ReactNode, useState } from "react";

const Section: FC<{
  label: ReactNode;
  children?: ReactNode;
  onClear?: any;
  filterKey:string;
  onReset?:any,
}> = ({
  label,
  children,
  onClear,
  filterKey,
  onReset,
}) => {
  const [isSelected, setIsSelected] = useState(true);
  const handleClick = (event:any)=>{
    event.stopPropagation();
    setIsSelected((val)=>{
      if (val) onClear(filterKey);
      if (!val) onReset(filterKey);
      return !val;
    })
  }
  return (
    <>
      <Collapse
        ghost
        items={[
          {
            forceRender: true,
            key: 1,
            label: (
              <div className="flex select-none gap-1 font-semibold">
                {onClear && (
                  <div
                    className="flex gap-2"
                    onClick={handleClick as any}
                  >
                    <Checkbox checked={isSelected} />
                  </div>
                )}{label}
                
              </div>
            ),
            children,
          },
        ]}
        defaultActiveKey={1}
        expandIconPlacement="end"
        classNames={{
          body: "pe-4! ps-4!",
        }}
      />
      <Divider className="m-0!" />
    </>
  );
};

export default Section;
